import { createMemo } from '@packages/react';
import React from 'react';
import ContentLoader from 'react-content-loader';

export const SummaryPackagePlaceholder = createMemo(
    () => {
        let y = 0;
        return (
            <ContentLoader
                speed={2}
                backgroundColor="#f5f5f5"
                foregroundColor="#eee"
                width={232}
                height={218}
                style={{ width: '100%' }}
            >
                <rect x="33" y={(y += 6)} rx="4" ry="4" width="166" height="150" />
                <rect x="62" y={(y += 150 + 12)} rx="4" ry="4" width="108" height="8" />
                <rect x="51" y={(y += 8 + 12)} rx="4" ry="4" width="130" height="8" />
                <rect x="71" y={y + 8 + 4} rx="4" ry="4" width="90" height="8" />
            </ContentLoader>
        );
    },
    {
        displayName: 'SummaryPackagePlaceholder',
    },
);
